var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.7325 31.5L25.5469 44.351C25.837 44.642 26 45.0367 26 45.4482C26 45.8598 25.837 46.2545 25.5469 46.5455C25.2568 46.8365 24.8633 47 24.453 47C24.0427 47 23.6493 46.8365 23.3591 46.5455L9.45391 32.5973C9.31003 32.4533 9.19587 32.2823 9.11798 32.094C9.04009 31.9057 9 31.7039 9 31.5C9 31.2961 9.04009 31.0943 9.11798 30.906C9.19587 30.7177 9.31003 30.5467 9.45391 30.4027L23.3591 16.4545C23.6493 16.1635 24.0427 16 24.453 16C24.8633 16 25.2568 16.1635 25.5469 16.4545C25.837 16.7455 26 17.1402 26 17.5518C26 17.9633 25.837 18.358 25.5469 18.649L12.7325 31.5Z",
    fill: "black",
    stroke: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.3c3eab293f735de968709c70f6aa0c25.svg";
export { ForwardRef as ReactComponent };